/* import __COLOCATED_TEMPLATE__ from './complex-component-configs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();